import { createFileRoute, redirect } from "@tanstack/react-router";

import { CaseEditPage } from "@/features/cases/case-edit-page";
import { caseDetailQueryOptions } from "@/features/cases/queries";
import { STATIC_LABELS } from "@/lib/nav-registry";

// DRAFT/REJECTED は通常編集、OPEN/IN_PROGRESS は公開後の再申請モード
const EDITABLE_STATUSES = ["DRAFT", "REJECTED", "OPEN", "IN_PROGRESS"];

// ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
// `redirect` は loader 内の status 不適合時の遷移で使う。
export const Route = createFileRoute("/_authenticated/enterprise/$id/edit")({
  staticData: { crumb: { label: STATIC_LABELS.enterpriseEdit } },
  loader: async ({ context, params }) => {
    const useCase = await context.queryClient.ensureQueryData(
      caseDetailQueryOptions(params.id),
    );
    if (!EDITABLE_STATUSES.includes(useCase.status)) {
      throw redirect({ to: "/enterprise/$id", params: { id: params.id } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <CaseEditPage id={id} />;
}
